import React, { useEffect, useState } from 'react'
import { MobileContainerPadding, PageTitle } from './index.style'
import { trans } from 'sharedKernel/i18n'
import { changeMenu, changeMenuEvaluator, store } from 'store'
import { GetFormat, useGet } from 'sharedKernel/api'
import { NoContent } from 'components/NoContent'
import { Loading } from 'components/loading'

import NoContentImg from 'assets/images/defaults/no_evaluations.png'
import { Container, Row, Col } from 'react-bootstrap'
import { FilterOrderByProps } from 'components/OrderBy'
import { IdeasAccordion } from 'domain/feature/hub/evaluator/components/IdeasAccordion'
import { Filter } from 'components/Filter'

export const HubEvaluatorChallengePage = ({ ...props }): JSX.Element => {
  const labels = {
    noContent: trans('Você ainda não possui nenhuma avaliação')
  }

  const request: GetFormat = {
    url: '/v1/hub/evaluator/challenge?page=1'
  }

  const orderByOptions = [
    {
      value: 'closed_first',
      label: 'Finalizada'
    },
    {
      value: 'open_first',
      label: 'Não Finalizada'
    }
  ]

  const { data, isLoading, refetch } = useGet(request, 'evaluator-challenges-get')
  const [selectedOrderBy, setSelectedOrderBy] = useState(orderByOptions[0])
  const [currentSearchTerm, setCurrentSearchTerm] = useState<string>('')

  useEffect(() => {
    store.dispatch(changeMenu(false))
  }, [])

  useEffect(() => {
    if (data != null) {
      store.dispatch(changeMenuEvaluator(data))
    }
  }, [data, selectedOrderBy])

  const onSearch = (searchTerm: string): void => {
    request.httpConfig = { params: { match: searchTerm } }
    setCurrentSearchTerm(searchTerm)
    refetch()
  }

  const onOrderBy = (selectedOrderBy: FilterOrderByProps): void => {
    setSelectedOrderBy(selectedOrderBy)
  }

  const renderResponse = (): JSX.Element => {
    if (isLoading) {
      return (
        <Loading />
      )
    }
    if (data == null) {
      return <NoContent text={labels.noContent} image={NoContentImg} />
    }

    return (
      <>
        <div>
            <PageTitle>Minhas avaliações</PageTitle>
            <Row className='mb-4' style={{ gap: '0' }}>
              <Col lg={6} style={{ padding: '0' }}>
                <Filter currentSearchTerm={currentSearchTerm} btnClick={onSearch} />
              </Col>
            </Row>
          </div>
        <Container className='p-0' fluid>
          <IdeasAccordion orderBy={selectedOrderBy.value} />
        </Container>
      </>
    )
  }

  return <>
    <MobileContainerPadding />
    {renderResponse()}
  </>
}
